module.exports = __webpack_public_path__ + "img/img_logo.be432e64.png";